import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDocs, Timestamp, query, where } from 'firebase/firestore';
import './FormStyleAppointment.css';
import { useTenant } from '../context/TenantContext';
import { toast } from 'react-toastify';
import { sendSMS } from '../utils/sendSMS';

const CreateAppointmentForm = () => {
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [formData, setFormData] = useState({
    patientId: '',
    doctorId: '',
    service: '',
    datetime: ''
  });
  const { tenantId, loading } = useTenant();

  useEffect(() => {
    const fetchData = async () => {
      const p = query(collection(db, 'patients'), where("tenantId", "==", tenantId));
      const d = query(collection(db, 'doctors'), where("tenantId", "==", tenantId));
      const patientsSnap = await getDocs(p);
      const doctorsSnap = await getDocs(d);
      setPatients(patientsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setDoctors(doctorsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      const patientsList = patientsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const doctorsList = doctorsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      console.log("Doctors fetched:", doctorsList);
      console.log("Patients fetched:", patientsList);
    };
    fetchData();
  }, [tenantId, loading]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'appointments'), {
        ...formData,
        datetime: Timestamp.fromDate(new Date(formData.datetime)),
        prescriptionId: null,
        createdAt: Timestamp.now(),
        tenantId
      });
      toast.success('Appointment created successfully!');
      setFormData({ patientId: '', doctorId: '', service: '', datetime: '', tenantId  });
      //await sendSMS('+918106644500', 'Hello from ClinicSync!')
    } catch (error) {
      console.error('Error creating appointment:', error);
      toast.error('Failed to create appointment.');
    }
  };

  return (
    <div className="form-container">
      <h2>Schedule Appointment</h2>
      <form onSubmit={handleSubmit}>
        <label>Patient:</label>
        <select name="patientId" value={formData.patientId} onChange={handleChange} required>
          <option value="">Select Patient</option>
          {patients.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <label>Doctor:</label>
        <select name="doctorId" value={formData.doctorId} onChange={handleChange} required>
          <option value="">Select Doctor</option>
          {doctors.map(d => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>

        <label>Service or Details:</label>
        <input type="text" name="service" value={formData.service} onChange={handleChange} placeholder="e.g. Cleaning, Checkup" required />

        <label>Date & Time:</label>
        <input type="datetime-local" name="datetime" value={formData.datetime} onChange={handleChange} required />

        <button type="submit">Create</button>
      </form>
    
    </div>
  );
};

export default CreateAppointmentForm;
